import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { Accordion as BSAccordion, Col, FormProps, Row } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { getAllAddressesMappedByType } from '../../services/addresses';
import { getAllStates } from '../../services/states';
import { Beneficiary } from '../../types';
import Button from '../Button';
import {
  default as DatePicker,
  default as DatePickerInput,
} from '../DatePicker';
import EditableAvatar from '../EditableAvatar';
import Select from '../Select';
import SSNInput from '../SSNInput';
import TextInput from '../TextInput';

const defaultBeneficiary: Beneficiary = {
  beneficiaryType: '',
  relationship: '',
  firstName: '',
  middleName: '',
  lastName: '',
  ssn: '',
  dob: '',
  title: '',
  suffix: '',
  gender: '',
  // sameAddress: 'false',
  // address1: '',
  // address2: '',
  // city: '',
  // state: '',
  // zipCode: '',
  entityName: '',
  entityId: '',
  trustDate: '',
};

export type AddEditBeneficiaryFormProps = FormProps &
  React.PropsWithRef<{
    existingBeneficiary?: Beneficiary;
    isForFamilyMember: boolean;
    handleClose: () => void;
    handleOnSubmit: (formData: any) => void;
  }>;

const beneficiaryTypes = [
  { label: 'Person', value: 'person' },
  { label: 'Trust', value: 'trust' },
  { label: 'Estate', value: 'estate' },
  { label: 'Other', value: 'other' },
];

const relationshipTypes = [
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Child', value: 'Child' },
];

const titles = [
  { label: 'Mr', value: '1' },
  { label: 'Mrs', value: '2' },
  { label: 'Miss', value: '3' },
];

const suffix = [
  { label: 'suffix 1', value: '1' },
  { label: 'suffix 2', value: '2' },
];

const gender = [
  { label: 'Female', value: 'female' },
  { label: 'Male', value: 'male' },
  { label: 'Neutral', value: 'neutral' },
];

const statesOptions = getAllStates();

const AddEditBeneficiaryForm = ({
  existingBeneficiary = defaultBeneficiary,
  isForFamilyMember,
  handleClose,
  handleOnSubmit,
  ...props
}: AddEditBeneficiaryFormProps) => {
  const [selectedType, setSelectedType] = useState('person');
  const [isPreselected, setIsPreselected] = useState(false);

  const handleOnTypeChange = (e: any) => {
    setSelectedType(e);
  };

  const addresses = getAllAddressesMappedByType();

  const handleOnSwitch = (e: any) => {
    setIsPreselected(e.target.checked);
  };

  const mainPersonValidationSchema = yup.object().shape({
    // address1: yup
    //   .string()
    //   .required('Address 1 is required')
    //   .max(245, 'Must be no longer than 245 characters'),
    // city: yup
    //   .string()
    //   .required('City is required')
    //   .max(245, 'Must be no longer than 245 characters'),
    // zipCode: yup.string().required('Zip Code is required'),

    relationship: yup
      .string()
      .required('Relationship is required')
      .max(245, 'Must be no longer than 245 characters'),
    firstName: yup
      .string()
      .required('First name is required')
      .max(245, 'Must be no longer than 245 characters'),
    lastName: yup
      .string()
      .required('Last Name is required')
      .max(245, 'Must be no longer than 245 characters'),
    ssn: yup
      .string()
      .nullable()
      .transform((v, o) => (o === '' ? null : v))
      .matches(/^\d{3}-?\d{2}-?\d{4}$/, 'SSN is 9 digits')
      .required('SSN is required'),

    // state: yup.string().required('State is required'),

    dob: yup.string().required('Date of Birth is required'),
    gender: yup.string().required('Gender is required'),
  });

  const mainTrustValidationSchema = yup.object().shape({
    // address1: yup
    //   .string()
    //   .required('Address 1 is required')
    //   .max(245, 'Must be no longer than 245 characters'),
    // city: yup
    //   .string()
    //   .required('City is required')
    //   .max(245, 'Must be no longer than 245 characters'),
    // state: yup.string().required('State is required'),
    // zipCode: yup.string().required('Zip Code is required'),

    entityName: yup.string().required('Entity is required'),
    entityId: yup.string().required('Entity is required'),
    trustDate: yup.string().required('Trust Effective Date is required'),
    beneficiaryType: yup.string(),
  });

  const mainEntityValidationSchema = yup.object().shape({
    // address1: yup
    //   .string()
    //   .required('Address 1 is required')
    //   .max(245, 'Must be no longer than 245 characters'),
    // city: yup
    //   .string()
    //   .required('City is required')
    //   .max(245, 'Must be no longer than 245 characters'),
    // state: yup.string().required('State is required'),
    // zipCode: yup.string().required('Zip Code is required'),

    entityName: yup.string().required('Entity is required'),
    entityId: yup.string().required('Entity is required'),
    beneficiaryType: yup.string(),
  });

  let validationSchema: any = mainTrustValidationSchema;
  if (isForFamilyMember) {
    validationSchema = mainPersonValidationSchema;
  } else {
    if (selectedType === 'person') {
      validationSchema = mainPersonValidationSchema;
    } else if (selectedType === 'trust') {
      validationSchema = mainTrustValidationSchema;
    } else {
      validationSchema = mainEntityValidationSchema;
    }
  }

  const {
    handleSubmit,
    formState: { errors, isDirty, isValid },
    control,
    setValue,
    trigger,
  } = useForm({
    defaultValues: defaultBeneficiary,
    resolver: yupResolver(validationSchema),
    mode: 'all',
  });

  // useEffect(() => {
  //   if (isPreselected) {
  //     setValue('address1', addresses.home[0].address1);
  //     setValue('city', addresses.home[0].city);
  //     setValue('zipCode', addresses.home[0].zipCode);
  //     setValue('state', addresses.home[0].state);
  //     trigger();
  //   } else {
  //     setValue('address1', '');
  //     setValue('city', '');
  //     setValue('zipCode', '');
  //     setValue('state', '');
  //     if (isDirty) trigger();
  //   }
  // }, [addresses.home, isDirty, isPreselected, setValue, trigger]);

  const handleSubmitForm = (formData: any) => {
    handleOnSubmit({ ...formData, beneficiaryType: selectedType });
    if (selectedType !== 'person') handleClose();
  };

  const date = new Date();

  return (
    <form onSubmit={handleSubmit(handleSubmitForm)} noValidate={true}>
      {!isForFamilyMember ? (
        <>
          <Row>
            <Col className="text-ligther-grey fw-ntext-fs-6 fw-light">
              Select the type of Beneficiary you want to add
            </Col>
          </Row>
          <Row className="pt-7 mb-12">
            <Col className="col-lg-6">
              <Controller
                name={'beneficiaryType'}
                control={control}
                render={({ field }) => {
                  field.value = selectedType;
                  return (
                    <Select
                      placeholder={'Type'}
                      options={beneficiaryTypes}
                      {...field}
                      isInvalid={!!errors.beneficiaryType}
                      onChange={handleOnTypeChange}
                    />
                  );
                }}
              />
              {errors.beneficiaryType && (
                <div className="error-message">
                  <span>{errors.beneficiaryType.message}</span>
                </div>
              )}
            </Col>
          </Row>
        </>
      ) : null}
      <Row>
        <Col>
          <EditableAvatar size={'large'} />
        </Col>
      </Row>
      <Row className="pt-12 ">
        <Col>
          {selectedType === 'person' && (
            <BSAccordion defaultActiveKey="0">
              <BSAccordion.Item eventKey="0" className="white-accordion">
                <BSAccordion.Header>Personal Details *</BSAccordion.Header>
                <BSAccordion.Body>
                  <Row className="pt-10">
                    <Col className="col-12 col-lg-6">
                      <Controller
                        name={'relationship'}
                        control={control}
                        render={({ field }) => (
                          <Select
                            options={relationshipTypes}
                            {...field}
                            isInvalid={!!errors.relationship}
                            label="Relationship"
                            placeholder="Relationship"
                          />
                        )}
                      />
                      {errors.relationship && (
                        <div className="error-message">
                          <span>{errors.relationship.message}</span>
                        </div>
                      )}
                    </Col>
                    <Col className="col-12 col-lg-6 pt-lg-0 pt-10">
                      <Controller
                        name={'firstName'}
                        control={control}
                        render={({ field }) => (
                          <TextInput
                            label="First Name"
                            isInvalid={!!errors.firstName}
                            {...field}
                          />
                        )}
                      />
                      {errors.firstName && (
                        <div className="error-message">
                          <span>{errors.firstName.message}</span>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="pt-10">
                    <Col className="col-12 col-lg-6 pt-lg-0 pt-10">
                      <Controller
                        name={'lastName'}
                        control={control}
                        render={({ field }) => (
                          <TextInput
                            label="Last Name"
                            isInvalid={!!errors.lastName}
                            {...field}
                          />
                        )}
                      />
                      {errors.lastName && (
                        <div className="error-message">
                          <span>{errors.lastName.message}</span>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="pt-10">
                    <Col className="col-12 col-lg-6">
                      <Controller
                        name={'ssn'}
                        control={control}
                        render={({ field }) => (
                          <SSNInput label={'SSN'} {...field} />
                        )}
                      />
                      {errors.ssn && (
                        <div className="error-message">
                          <span>{errors.ssn.message}</span>
                        </div>
                      )}
                    </Col>
                    <Col className="col-12 col-lg-6 pt-lg-0 pt-10">
                      <Controller
                        name={'dob'}
                        control={control}
                        render={({ field }) => (
                          <DatePickerInput
                            maxDate={date}
                            placeholder={'Date of Birth'}
                            label={'Date of Birth'}
                            {...field}
                          />
                        )}
                      />
                      {errors.dob && (
                        <div className="error-message">
                          <span>{errors.dob.message}</span>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="pt-10">
                    <Col className="pt-lg-0 pt-10">
                      <Controller
                        name={'suffix'}
                        control={control}
                        render={({ field }) => (
                          <Select
                            label="Suffix  (Optional)"
                            options={suffix}
                            {...field}
                            isInvalid={!!errors.suffix}
                          />
                        )}
                      />
                      {errors.suffix && (
                        <div className="error-message">
                          <span>{errors.suffix.message}</span>
                        </div>
                      )}
                    </Col>
                    <Col className="pt-lg-0 pt-10">
                      <Controller
                        name={'gender'}
                        control={control}
                        render={({ field }) => (
                          <Select
                            label="Gender"
                            options={gender}
                            {...field}
                            isInvalid={!!errors.gender}
                          />
                        )}
                      />
                      {errors.gender && (
                        <div className="error-message">
                          <span>{errors.gender.message}</span>
                        </div>
                      )}
                    </Col>
                  </Row>
                </BSAccordion.Body>
              </BSAccordion.Item>
            </BSAccordion>
          )}
          {selectedType !== 'person' && (
            <BSAccordion defaultActiveKey="0">
              <BSAccordion.Item eventKey="0" className="white-accordion">
                <BSAccordion.Header>Entity Details *</BSAccordion.Header>
                <BSAccordion.Body>
                  <Row className="pt-10">
                    <Col className="col-12 col-lg-6 pt-lg-0 pt-10">
                      <Controller
                        name={'entityName'}
                        control={control}
                        render={({ field }) => (
                          <TextInput
                            label="Entity Name"
                            isInvalid={!!errors.entityName}
                            {...field}
                          />
                        )}
                      />
                      {errors.entityName && (
                        <div className="error-message">
                          <span>{errors.entityName.message}</span>
                        </div>
                      )}
                    </Col>
                    <Col className="col-12 col-lg-6 pt-lg-0 pt-10">
                      <Controller
                        name={'entityId'}
                        control={control}
                        render={({ field }) => (
                          <TextInput
                            label="ID"
                            isInvalid={!!errors.entityId}
                            {...field}
                          />
                        )}
                      />
                      {errors.entityId && (
                        <div className="error-message">
                          <span>{errors.entityId.message}</span>
                        </div>
                      )}
                    </Col>
                  </Row>
                  {selectedType === 'trust' && (
                    <Row className="pt-10">
                      <Col className="col-12 col-lg-6">
                        <Controller
                          name={'trustDate'}
                          control={control}
                          render={({ field }) => (
                            <DatePicker
                              label="Trust Effective Date"
                              {...field}
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  )}
                </BSAccordion.Body>
              </BSAccordion.Item>
            </BSAccordion>
          )}
        </Col>
      </Row>
      {/* probably will be used at some point */}
      {/* <Row className="pt-12 white-accordion-item ">
        <Col>
          <BSAccordion defaultActiveKey="0">
            <BSAccordion.Item eventKey="0" className="white-accordion">
              <BSAccordion.Header>Address *</BSAccordion.Header>
              <BSAccordion.Body>
                <Row>
                  <Col>
                    <Controller
                      name={'sameAddress'}
                      control={control}
                      render={({ field }) => (
                        <Switch
                          className="mt-6"
                          label={'Same address as employee'}
                          checked={isPreselected}
                          onChange={handleOnSwitch}
                        />
                      )}
                    />
                  </Col>
                </Row>

                <Controller
                  name={'address1'}
                  control={control}
                  render={({ field }) => (
                    <TextInput
                      leftIcon={light('location-pin')}
                      label="Address 1"
                      className="mt-8"
                      placeholder="Address"
                      isInvalid={!!errors.address1}
                      {...field}
                    />
                  )}
                />
                {errors.address1 && (
                  <div className="error-message">
                    <span>{errors.address1.message}</span>
                  </div>
                )}

                <Controller
                  name={'address2'}
                  control={control}
                  render={({ field }) => (
                    <TextInput
                      leftIcon={light('location-pin')}
                      label="Address 2 (Optional)"
                      className="mt-8"
                      placeholder="Address"
                      {...field}
                    />
                  )}
                />

                <Row className="mt-8">
                  <Col className="col-12 col-lg-3">
                    <Controller
                      name={'city'}
                      control={control}
                      render={({ field }) => (
                        <TextInput
                          label="City"
                          isInvalid={!!errors.city}
                          {...field}
                        />
                      )}
                    />
                    {errors.city && (
                      <div className="error-message">
                        <span>{errors.city.message}</span>
                      </div>
                    )}
                  </Col>

                  <Col className="mt-4 mt-lg-0 col-12 col-lg-6">
                    <Controller
                      name={'state'}
                      control={control}
                      render={({ field }) => (
                        <Select
                          label="State"
                          options={statesOptions}
                          {...field}
                          isInvalid={!!errors.state}
                        />
                      )}
                    />
                    {errors.state && (
                      <div className="error-message">
                        <span>{errors.state.message}</span>
                      </div>
                    )}
                  </Col>

                  <Col className="mt-4 mt-lg-0 col-12 col-lg-3">
                    <Controller
                      name={'zipCode'}
                      control={control}
                      render={({ field }) => (
                        <TextInput
                          label="ZIP Code"
                          {...field}
                          isInvalid={!!errors.zipCode}
                          maxLength={5}
                        />
                      )}
                    />
                    {errors.zipCode && (
                      <div className="error-message">
                        <span>{errors.zipCode.message}</span>
                      </div>
                    )}
                  </Col>
                </Row>
              </BSAccordion.Body>
            </BSAccordion.Item>
          </BSAccordion>
        </Col>
      </Row> */}
      <Row>
        <Col>
          <section className="py-11 py-lg-12 d-flex justify-content-center flex-column flex-lg-row">
            <Button
              className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1"
              variant="primary-outline"
              onMouseDown={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="order-1 order-lg-2"
              type="submit"
              disabled={!isDirty || !isValid}
            >
              {selectedType === 'person' ? 'Continue' : 'Add'}
            </Button>
          </section>
        </Col>
      </Row>
    </form>
  );
};
export default AddEditBeneficiaryForm;
